var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"404"},[_c('NavBar'),_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Cette page n'existe pas.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("retour à l'accueil")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }